/* Showtime cutouts: used by the Outfit Builder (Flat lay + Styled fit), ready-made fits and the homepage (img[data-cutout]).
   - Already-transparent photos (PNG cutouts, often with their own studio shadow) are only trimmed ("is-native").
   - Plain backgrounds are removed and trimmed. Light items (cream, white, bone) get a second, much finer pass that
     only removes the pure background, so their edges stay intact. Busy or white-on-white photos keep the original.
   - A pixel is never made more opaque than in the original photo (prevents dark fringe lines).
   - Every cutout gets one soft studio shadow; native PNGs keep their own.
   - window.STCUT() re-scans the page for new images (used when outfits are added after load). */
(function(){
var SH='drop-shadow(0 10px 16px rgba(0,0,0,.17))';
var css=document.createElement('style');
css.textContent='img.is-cut{filter:'+SH+'!important}'+
'img.is-cut.is-native{filter:none!important}'+
'img.ob-twin.is-cut,img.sto__shoe-back.is-cut{filter:brightness(.9) '+SH+'!important}'+
'img.ob-twin.is-cut.is-native,img.sto__shoe-back.is-cut.is-native{filter:brightness(.9)!important}'+
'#st-ob .ob-pic:after{content:"";position:absolute;left:28%;right:28%;bottom:6%;height:16px;border-radius:50%;background:radial-gradient(ellipse at center,rgba(0,0,0,.13),rgba(0,0,0,0) 70%);pointer-events:none;z-index:0}'+
'#st-ob .ob-pic img{position:relative;z-index:1}';
document.head.appendChild(css);
var cache={},SIZE=1000;
function hiRes(u){if(u.indexOf('cdn.shopify.com')<0&&u.indexOf('/cdn/shop/')<0)return u;return /[?&]width=\d+/.test(u)?u.replace(/([?&])width=\d+/,'$1width='+SIZE):u+(u.indexOf('?')>-1?'&':'?')+'width='+SIZE;}
function trim(c,p,w,h){
  var minX=w,minY=h,maxX=0,maxY=0;
  for(var y=0;y<h;y++)for(var x=0;x<w;x++){if(p[(y*w+x)*4+3]>16){if(x<minX)minX=x;if(x>maxX)maxX=x;if(y<minY)minY=y;if(y>maxY)maxY=y;}}
  if(maxX<=minX||maxY<=minY)return null;
  var cw=maxX-minX+1,ch=maxY-minY+1,o=document.createElement('canvas');o.width=cw;o.height=ch;
  o.getContext('2d').drawImage(c,minX,minY,cw,ch,0,0,cw,ch);return o.toDataURL('image/png');
}
function pass(p,w,h,bg,TOL,SOFT,lightCheck){
  var N=w*h,cd=function(n){var i=n*4,a=p[i]-bg[0],e=p[i+1]-bg[1],f=p[i+2]-bg[2];return Math.sqrt(a*a+e*e+f*f);};
  var bgm=new Uint8Array(N),seen=new Uint8Array(N),st=[];
  var push=function(n){if(seen[n])return;seen[n]=1;if(cd(n)<=TOL||p[n*4+3]<20)st.push(n);};
  for(var X=0;X<w;X++){push(X);push((h-1)*w+X);}for(var Y=0;Y<h;Y++){push(Y*w);push(Y*w+w-1);}
  while(st.length){var n=st.pop();bgm[n]=1;var px=n%w;if(px>0)push(n-1);if(px<w-1)push(n+1);if(n>=w)push(n-w);if(n<N-w)push(n+w);}
  var removed=0,item=0,light=0;
  for(var k=0;k<N;k++){if(bgm[k]){removed++;continue;}item++;if(cd(k)<75)light++;}
  if(removed<N*.05||removed>N*.88)return null;
  if(lightCheck&&item&&light/item>.3)return 'light';
  for(var k2=0;k2<N;k2++){var i2=k2*4;
    if(bgm[k2]){p[i2+3]=0;continue;}
    var x2=k2%w,edge=(x2>0&&bgm[k2-1])||(x2<w-1&&bgm[k2+1])||(k2>=w&&bgm[k2-w])||(k2<N-w&&bgm[k2+w]);
    if(!edge)continue;
    var t=(cd(k2)-TOL)/(SOFT-TOL),a=t<.35?0:t>=1?255:Math.round(t*255);
    p[i2+3]=Math.min(p[i2+3],a);}
  return 'ok';
}
function cutout(url){
  if(cache[url])return cache[url];
  cache[url]=new Promise(function(resolve){
    var im=new Image();im.crossOrigin='anonymous';
    im.onload=function(){
      try{
        var sc=Math.min(1,SIZE/Math.max(im.naturalWidth,im.naturalHeight)),w=Math.round(im.naturalWidth*sc),h=Math.round(im.naturalHeight*sc);
        var c=document.createElement('canvas');c.width=w;c.height=h;var x=c.getContext('2d');x.imageSmoothingQuality='high';x.drawImage(im,0,0,w,h);
        var d=x.getImageData(0,0,w,h),p=d.data;
        var pts=[[2,2],[w-3,2],[2,h-3],[w-3,h-3]];
        if(pts.some(function(q){return p[(q[1]*w+q[0])*4+3]<200;})){var t0=trim(c,p,w,h);resolve(t0?{src:t0,native:true}:null);return;}
        var bg=[0,0,0],cs=[];
        pts.forEach(function(q){var i=(q[1]*w+q[0])*4;cs.push([p[i],p[i+1],p[i+2]]);bg[0]+=p[i]/4;bg[1]+=p[i+1]/4;bg[2]+=p[i+2]/4;});
        if(cs.some(function(k){var a=k[0]-bg[0],e=k[1]-bg[1],f=k[2]-bg[2];return Math.sqrt(a*a+e*e+f*f)>40;})){resolve(null);return;}
        var orig=new Uint8ClampedArray(p);
        var r=pass(p,w,h,bg,28,60,true);
        if(r==='light'){p.set(orig);r=pass(p,w,h,bg,9,26,false);}
        if(r!=='ok'){resolve(null);return;}
        x.putImageData(d,0,0);
        var t1=trim(c,p,w,h);resolve(t1?{src:t1,native:false}:null);
      }catch(e){resolve(null);}
    };
    im.onerror=function(){resolve(null);};
    im.src=hiRes(url);
  });
  return cache[url];
}
function apply(img){
  var src=img.getAttribute('src')||'';if(!src||src.indexOf('data:')===0||img.dataset.cutFor===src)return;
  img.dataset.cutFor=src;img.classList.remove('is-cut','is-native');
  cutout(src).then(function(out){
    if(img.dataset.cutFor!==src)return;
    if(out){img.dataset.orig=src;img.src=out.src;img.dataset.cutFor=out.src;img.classList.add('is-cut');if(out.native)img.classList.add('is-native');}
    pair(img);
  });
}
function pair(img){
  var box=img.closest('.ob-on--shoe');if(!box)return;
  var twin=box.querySelector('.ob-twin');if(!twin){twin=document.createElement('img');twin.className='ob-twin';twin.alt='';box.appendChild(twin);}
  twin.src=img.src;twin.hidden=img.hidden;
  twin.classList.toggle('is-cut',img.classList.contains('is-cut'));twin.classList.toggle('is-native',img.classList.contains('is-native'));
}
function init(){
  document.querySelectorAll('#st-ob .ob-on img:not(.ob-twin), #st-ob .ob-pic img, img[data-cutout]').forEach(function(img){
    if(img.dataset.cutWatch)return;img.dataset.cutWatch='1';
    new MutationObserver(function(){apply(img);if(img.closest('.ob-on--shoe'))pair(img);}).observe(img,{attributes:true,attributeFilter:['src','hidden']});
    if(img.getAttribute('src'))apply(img);
  });
}
window.STCUT=init;
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();